import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="storage-array-form"
export default class extends Controller {
  static targets = ['serviceDeactivationDate', 'serviceDeactivationReason'];

  connect() {
    $(this.serviceDeactivationDateTarget).on('change', () => { this.toggleVisibility(); });
  }

  toggleVisibility() {
    const deactivationDate = $(this.serviceDeactivationDateTarget);
    const deactivationReason = $(this.serviceDeactivationReasonTarget);

    if (deactivationDate.val()){
      deactivationReason.removeClass('d-none');
    } else {
      deactivationReason.addClass('d-none');
    }
  }

  triggerCheckSerialNumber(event){
    const element = $(event.target);
    const type = element.data('type') || 'GET';
    const url = element.data('url');
    const formElement = $('#' + element.closest('form').attr('id'));

    $.ajax({
      type: type,
      url: url,
      data: formElement.serialize() });
  }
}
